import { queryClient } from "@/pages/_app";

import api from "@/services/api";

export const citySearchApiCall = (input: string, callback: any) => {
  return api.candidate
    .getCities({
      search: input,
    })
    .then((res) => callback(res.data?.results));
};

export const interviewerSearchApiCall = (input: string, callback: any) => {
  return api.interviewer
    .getInterviewers({ search: input })
    .then((res) => callback(res.data.results));
};

export const activeInterviewerSearchApiCall = (
  input: string,
  callback: any,
) => {
  return api.interviewer
    .getInterviewers({ search: input, active: "true" })
    .then((res) => callback(res.data.results));
};

export const companySearchApiCall = (input: string, callback: any) => {
  return api.company
    .getCompanies({ search: input })
    .then((res) => callback(res.data.results));
};

export const clientCompanySearchApiCall = (input: string, callback: any) => {
  return api.company
    .getCompanies({ search: input, is_client: true })
    .then((res) => callback(res.data.results));
};

export const candidateSearchApiCall = (input: string, callback: any) => {
  return api.candidate
    .getCandidates({
      search: input,
    })
    .then((res) => callback(res.data.results));
};

export const recruiterSearchApiCall = (input: string, callback: any) => {
  return api.auth
    .getUser({ new_role__name: "Recruiter", search: input })
    .then((res) => callback(res.data.results));
};

export const assessmentTypeSearchApiCall = (
  input: string,
  callback: (results: any) => void,
) => {
  return queryClient
    .fetchQuery(
      ["ASSESSMENT_TEMPLATE", "LIST", { search: input, is_published: true }],
      () =>
        api.assessments.getAssessmentTemplates({
          search: input,
          is_published: "true",
        }),
    )
    .then((res) => callback(res.data.results));
};

export const institutionSearchApiCall = (input: string, callback: any) => {
  return api.candidate
    .getInstitution({ search: input })
    .then((res) => callback(res.data.results));
};

export const degreeSearchApiCall = (input: string, callback: any) => {
  return api.candidate
    .getDegree({ search: input })
    .then((res) => callback(res.data.results));
};

export const specializationSearchApiCall = (input: string, callback: any) => {
  return api.candidate
    .getSpecialization({ search: input })
    .then((res) => callback(res.data.results));
};

export const saveListSearchApiCall = (input: string, callback: any) => {
  return api.candidate
    .getSaveList({ search: input })
    .then((res) => callback(res.data.results));
};

export const jobRoleSearchApiCall = (input: string, callback: any) => {
  return queryClient
    .fetchQuery(["JOB_ROLE", "LIST", { search: input }], () =>
      api.candidate.getRoles({ search: input }),
    )
    .then((res) => callback(res.data.results));
};

export const skillSearchApiCall = (
  input: string,
  callback: (results: any) => void,
) => {
  return queryClient
    .fetchQuery(["SKILLS", "LIST", { search: input }], () =>
      api.candidate.getSkills({ search: input }),
    )
    .then((res) => callback(res.data.results));
};

export const industrySearchApiCall = (input: string, callback: any) => {
  return api.company
    .getIndustries({
      search: input,
    })
    .then((res) => callback(res.data.results));
};

export const companyBusinessTypeApiCall = (input: string, callback: any) => {
  return api.company
    .getCompanyBusinessType({
      search: input,
    })
    .then((res) => callback(res.data));
};

export const editorLanguageSearchApiCall = (input: string, callback: any) => {
  return api.assessments
    .getEditorLanguages({
      search: input,
    })
    .then((res) => callback(res.data.results));
};

export const assessmentExperienceSearchApiCall = (
  input: string,
  callback: any,
) => {
  return api.assessments
    .getAssessmentExperienceLevel({
      search: input,
    })
    .then((res) => callback(res.data.results));
};

export const jobRequirementSearchApiCall = (input: string, callback: any) => {
  return api.company
    .getJobs({ search: input, status: "Active" })
    .then((res) => callback(res.data.results));
};

export const screeningQuestionsSearchApiCall = (
  input: string,
  callback: any,
) => {
  return api.recruiter
    .getScreeningQuestions({ search: input })
    .then((res) => callback(res.data));
};

export const socialPlatformSearchApiCall = (input: string, callback: any) => {
  return api.candidate
    .getPlatforms({ search: input })
    .then((res) => callback(res.data));
};

export const tagSearchApiCall = (input: string, callback: any) => {
  return api.recruiter
    .getTags({ search: input })
    .then((res) => callback(res.data.results));
};

export const companyContactSearchApiCall = (params: any, callback: any) => {
  return queryClient
    .fetchQuery(["COMPANY_CONTACT", "LIST", params], () =>
      api.company.getHiringContacts(params),
    )
    .then((data) => callback(data.data.results));
};
